import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {IntegrationListData} from "@/lib/types/integrations.ts";
import {getIntegrationModuleInfo} from "@/pages/integrations/integrations.types.ts";
import {IntegrationLogs} from "@/pages/integrations/log/IntegrationLogs.tsx";

import styles from "./IntegrationLogsModal.module.scss";

interface TestIntegrationModalProps {
  show: boolean;
  hide: () => void;
  integration: IntegrationListData;
}

export const IntegrationLogsModal = ({show, hide, integration}: TestIntegrationModalProps) => {
  const moduleInfo = getIntegrationModuleInfo(integration.module);
  return (
    <UpErrorBoundary>
      <FormModal
        title={
          <div className={"d-flex align-items-center"}>
            Error Log:
            {moduleInfo?.logo && (
              <img
                src={moduleInfo.logo}
                alt={moduleInfo.label}
                height={22}
                width={22}
                className={"pulse-border-radius-xl ms-2"}
              />
            )}
            <span className={"ms-2"}>{integration.name}</span>
          </div>
        }
        onCancel={hide}
        show={show}
        size="lg"
        hasSubmitButton={false}
        cancelBtnText="Close"
        bodyClassName={styles.modalBody}
      >
        <IntegrationLogs integration={integration} />
      </FormModal>
    </UpErrorBoundary>
  );
};
